import { render } from "./AppRegistration.vue?vue&type=template&id=5a72e42c&scoped=true"
import script from "./AppRegistration.vue?vue&type=script&lang=js"
export * from "./AppRegistration.vue?vue&type=script&lang=js"

import "@/Common/Styles/registrationModal.scss?vue&type=style&index=0&id=5a72e42c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a72e42c"]])

export default __exports__